import React from "react";

type UnauthenticatedActionsProps = {
  isVisible: boolean;
  onShowAuthForm: () => void;
  buttonLabel: string;
};

function DemoUnauthenticatedActions({
  isVisible,
  onShowAuthForm,
  buttonLabel,
}: UnauthenticatedActionsProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-[100%] animate-fade-in">
      <div className="w-full tablet:pl-[86px] main:pl-[138px]">
        <button
          onClick={onShowAuthForm}
          className="col-span-2 w-[504px] max-w-full rounded-2xl bg-primary px-4 py-4 text-body1 font-[500] text-white"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}

export default DemoUnauthenticatedActions;
